
export enum Currency {
    Czk = 1,
    Eur = 2,
}